import { Injectable } from '@angular/core';

export type Operacion = 'sum' | 'avg' | 'min' | 'max';

@Injectable({
  providedIn: 'root'
})
export class CalculadorService {

  constructor() { }


  calcular<T>(array: T[], prop: keyof T, operacion: Operacion = 'sum'): number {
    const values = array.map(item => Number(item[prop])).filter(v => !isNaN(v));

    switch (operacion) {
      case 'sum':
        return values.reduce((acc, val) => acc + val, 0);
      case 'avg':
        return values.length ? values.reduce((acc, val) => acc + val, 0) / values.length : 0;
      case 'min':
        return Math.min(...values);
      case 'max':
        return Math.max(...values);
      default:
        return 0;
    }
  }
}
